import Snappy from '../../../libs/snappy/snappy';


Snappy.Component.Survey = class survey extends Snappy.BaseComponent {
        static get tagName() {
            return 'fa-survey';
        }

        setVars() {
            this.SurveyUniqueID = this.$element.find('.SurveyUniqueID').text();
            this.$buttonOpen = this.$element.find('.accept-cta');
            this.$buttonClose = this.$element.find('.decline-cta');
            this.surveyAlreadyActionedByUserKey = 'fa-survey-actioned' + this.SurveyUniqueID;            
            this.surveyVisibilityKey = 'fa-survey-visible';            
            this.activeClass = 'active';
            this.cookieVisibilityKey = 'fa-cookie-visible';

        }

        setEventListeners() {
            this.$buttonOpen.on('click', this.acceptSurvey.bind(this));
            this.$buttonClose.on('click', this.declineSurvey.bind(this));
        }


        acceptSurvey() {
            this.setSurveyAlreadyActionedByUserStatus();
            var url = this.$element.find('.ButtonYesUrl').text();
            this.hideSurveyMessage();
            this.setSurveyMessageVisibility(false);
            window.open(url, "_blank");
        }

        declineSurvey() {
            this.setSurveyAlreadyActionedByUserStatus();
            this.hideSurveyMessage();
            this.setSurveyMessageVisibility(false);
        }

        setSurveyAlreadyActionedByUserStatus() {            
            localStorage.setItem(this.surveyAlreadyActionedByUserKey, "True");
        }

        setSurveyMessageVisibility(visible) {
            localStorage.setItem(this.surveyVisibilityKey, visible);
        }   
    

        hideSurveyMessage() {
            this.$element.removeClass(this.activeClass);
        }

        constructor(element) {
            super(element);
        }

        render() {
            this.setVars();
            this.setEventListeners();            
        }
    };




// WEBPACK FOOTER //
// ./components/survey/scripts/survey.js